import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import type { Store } from '@reduxjs/toolkit';
import type { QueryClient } from '@tanstack/react-query';
import Loading from '../pages/Loading/Loading';
import { useAuthInit } from '../hooks/useAuthInit';

interface RouterContext {
  store: Store;
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  pendingComponent: Loading,
});

function RootComponent() {
  const { isLoading } = useAuthInit();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Suspense fallback={<Loading />}>
      <Outlet />
    </Suspense>
  );
}
